module.exports = require("./naq.js");